/**
 * Baesolé Quickadd: Represent-style maatkeuze in grid op afbeelding
 * Plaats deze volledige code in custom.js
 */
document.addEventListener('DOMContentLoaded', function () {
  // Plusje toont maten (en verbergt andere geopende popups)
  document.querySelectorAll('.baesole-card__plusbtn-grid').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var quickAdd = btn.closest('.baesole-card__quickadd-grid');
      var sizes = quickAdd.querySelector('.baesole-card__sizes-grid');
      // Andere popups sluiten
      document.querySelectorAll('.baesole-card__sizes-grid').forEach(function(s) {
        if (s !== sizes) s.style.display = 'none';
      });
      // Huidige toggelen
      sizes.style.display = (sizes.style.display === 'flex') ? 'none' : 'flex';
    });
  });

  // Klik buiten popup sluit alle maat-popups
  document.addEventListener('click', function() {
    document.querySelectorAll('.baesole-card__sizes-grid').forEach(function(s) {
      s.style.display = 'none';
    });
  });

  // Klik binnen popup sluit popup niet direct
  document.querySelectorAll('.baesole-card__sizes-grid').forEach(function(sizes) {
    sizes.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  // Maat toevoegen aan winkelmand + automatisch cart drawer openen
  document.querySelectorAll('.baesole-card__sizebtn-grid').forEach(function(sizeBtn) {
    sizeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = sizeBtn.getAttribute('data-variant');
      sizeBtn.disabled = true;
      var oldText = sizeBtn.textContent;
      sizeBtn.textContent = 'Toegevoegd...';

      // Shopify AJAX Cart add
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity: 1, id: variantId })
      })
      .then(res => res.json())
      .then(function() {
        sizeBtn.textContent = 'Toegevoegd!';
        sizeBtn.closest('.baesole-card__sizes-grid').style.display = 'none';
        document.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            variant: { id: variantId },
            quantity: 1
          }
        }));

        // Cart drawer openen (Prestige, of fallback)
        if (window.Shopify && Shopify.theme && Shopify.theme.cartDrawer && Shopify.theme.cartDrawer.open) {
          Shopify.theme.cartDrawer.open();
        } else if (document.querySelector('[data-drawer-open]')) {
          document.querySelector('[data-drawer-open]').click();
        }

        setTimeout(function() {
          sizeBtn.disabled = false;
          sizeBtn.textContent = oldText;
        }, 1500);
      })
      .catch(function() {
        sizeBtn.textContent = 'Mislukt!';
        sizeBtn.disabled = false;
        setTimeout(function() {
          sizeBtn.textContent = oldText;
        }, 1500);
      });
    });
    // Save original tekst voor reset
    sizeBtn.setAttribute('data-original', sizeBtn.textContent);
  });
});
